import React from "react"
import DashboardLayout from "core/layouts/DashboardLayout"
import Input from "core/components/new/Input"
import StandaredSelect from "core/components/StandaredSelect"
import CopyIcon from "assets/svgs/Copy"
import CircularProgress from "@mui/material/CircularProgress"
import Box from "@mui/material/Box"
import { STR_SUCCESS } from "core/constants/strings"
import useToast from "core/hooks/useToast"
import Toast from "core/components/Toast"
import ProgressMeetingFeedbackViewModel from "./ProgressMeetingFeedbackViewModel"
import { useLocation } from "react-router-dom"
import ProgressMeetFeedbackCard from "./components/ProgressMeetFeedbackCard"
import { ProgressMeetFeedback } from "domain/model/ProgressMeet"
import { copyToClipboard } from "core/utils/copyToClipboard"

export default function ProgressMeetingFeedback() {
  const {
    setSelectedPageTab,
    selectedPageTab,
    handlePageTabClick,
    selectedTab,
    setSelectedTab,
    handleTabClick,
    getBatches,
    batch,
    setBatch,
    handleBatchChange,
    studentBatch,
    getProgressMeetFeedback,
    setProgressMeetFeedback,
    progressMeetFeedback,
    filteredFeedback,
    feedbackKeys,
    fromDate,
    toDate,
    handleDateChange,
    searchByEmail,
    handleChange,
    handleSearch,
  } = ProgressMeetingFeedbackViewModel()
  const { toast, changeToastDetails, changeToastVisibility } = useToast()
  const [noResultsMessage, setNoResultsMessage] = React.useState<string | null>("No Data Found")
  const [loading, setLoading] = React.useState(true)
  const items = ["NPS", "LIVE CLASSES", "EXAMS", "MENTORSHIP", "CONTENT", "DOUBT SUPPORT"]
  const tabs = ["All Students", "Less Than or Equal to 6", "7-8 Rating", "9-10 Rating"]
  const queryParams = new URLSearchParams(window.location.search)
  const meetingId = queryParams.get("meetingId")
  const [selectedFeedback, setSelectedFeedback] = React.useState<ProgressMeetFeedback | null>(null)
  const [isFeedbackCardOpen, setIsFeedbackCardOpen] = React.useState(false)

  React.useEffect(() => {
    const fetchData = async () => {
      if (meetingId) {
        setLoading(true)
        await getProgressMeetFeedback(meetingId)
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  React.useEffect(() => {
    getBatches()
  }, [])
  const handleCopyToClipboard = (email: string) => {
    copyToClipboard(email)
  }
  const handleViewFeedback = (feedback: ProgressMeetFeedback) => {
    const fullFeedbackData = progressMeetFeedback.find((fb: ProgressMeetFeedback) => fb.email === feedback.email)

    setSelectedFeedback(fullFeedbackData || feedback)
    setIsFeedbackCardOpen(true)
  }

  return (
    <DashboardLayout>
      {toast && (
        <Toast
          data={toast}
          onClick={() => changeToastVisibility(false)}
          className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50"
        />
      )}
      <div className="flex ">
        <div className="w-4/5 p-4 m-2.5 border border-gray-300 rounded-md ">
          <div className="mb-4">
            <h2 className="text-2xl font-bold text-gray-600">Progress Meeting Feedback</h2>
            <p className="text-[#737373]">Track all data of Overall product performance.</p>
          </div>
          <div className="flex items-end mb-3">
            <Input
              id="email"
              type="text"
              className="w-[300px]"
              placeholder="Email Id"
              value={searchByEmail}
              onChange={handleChange}
            />

            <button
              className="border-[1px] px-[12px] rounded-md p-1 ml-2 hover:bg-new-accent hover:text-white hover:cursor-pointer"
              onClick={handleSearch}
              id="button"
            >
              Search
            </button>
          </div>
          <div className="flex space-x-2 mb-5"></div>
          <div className="flex items-start gap-2 p-[4px_6px] rounded border border-[#EBEBEB] bg-[#EBEBEB] w-fit h-[43px] mt-6">
            {items.map((item, index) => (
              <div
                key={index}
                className={`flex justify-center items-center gap-[13px] p-[9px_16px] rounded  shadow-[1px_1px_2px_-1px_rgba(34,41,48,0.05)] h-[33px] hover:cursor-pointer 
                           ${selectedPageTab === item ? " bg-white" : "hover:bg-white"}`}
                onClick={() => {
                  handlePageTabClick(item)
                }}
              >
                {item}
              </div>
            ))}
          </div>
          <div className="flex space-x-2 mt-6">
            {tabs.map((tab, index) => (
              <div
                key={index}
                className={`border border-gray-300 p-2 rounded-md transition-colors hover:cursor-pointer
                               ${selectedTab === tab ? "bg-[#162456] text-white" : "hover:bg-[#162456] hover:text-white"}`}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </div>
            ))}
          </div>
          <table className="w-full border border-gray-300 rounded-md mt-6">
            <thead className="bg-gray-800 w-full">
              <tr className="bg-gray-800 ">
                <th className="px-4 py-2 text-left text-white font-normal tracking-wider rounded-tl-md">
                  Student Name
                </th>
                <th className="px-4 py-2 text-left text-white font-normal  tracking-wider"></th>
                <th className="px-4 py-2 text-left text-white font-normal  tracking-wider">Rating</th>
                <th className="px-4 py-2 text-left text-white font-normal  tracking-wider">Batch</th>
                <th className="px-4 py-2 text-left text-white font-normal  tracking-wider">Submitted On</th>
                <th className="px-4 py-2 text-left text-white font-normal tracking-wider rounded-tr-md"></th>
              </tr>
            </thead>
            {loading && (
              <tr>
                <td colSpan={4} className="px-4 py-2 text-center m-auto">
                  <div className="m-auto">
                    <Box sx={{ display: "flex", marginLeft: "25vw" }}>
                      <CircularProgress />
                    </Box>
                  </div>
                </td>
              </tr>
            )}
            <tbody>
              {filteredFeedback?.length > 0 ? (
                [...filteredFeedback]
                  .sort((a, b) => (Number(b.timestamp) || 0) - (Number(a.timestamp) || 0))
                  .map((f: any, index: number) => (
                    <tr key={index} className="hello p-1 rounded-md hover:bg-gray-200 duration-500">
                      <td className="pl-4 py-2">
                        <div className="flex items-center">
                          <span>{f["name"]}</span>
                        </div>
                      </td>
                      <td className="relative group py-2">
                        <button onClick={() => handleCopyToClipboard(f.email)} className="relative z-10">
                          <CopyIcon />
                        </button>
                      </td>
                      <td className="px-4 py-2 relative group">
                        <span
                          className={`font-bold ${
                            f[feedbackKeys[selectedPageTab]] >= 9
                              ? "text-green-500"
                              : f[feedbackKeys[selectedPageTab]] >= 7
                                ? "text-yellow-500"
                                : "text-red-500"
                          }`}
                        >
                          {f[feedbackKeys[selectedPageTab]]}/10
                        </span>
                      </td>
                      <td className="px-4 py-2">{f["batch"]}</td>
                      <td className="px-4 py-2">
                        {new Date(f["timestamp"])
                          .toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "short",
                            day: "2-digit",
                          })
                          .replace(",", "")}
                      </td>
                      <td className="px-1 py-2 relative group items-center pl-10">
                        <button
                          className="bg-white border border-gray-300 text-gray-600 hover:bg-gray-100 hover:text-black py-2 px-4 rounded focus:outline-none focus:shadow-outline hover:border-gray-600"
                          type="button"
                          onClick={() => handleViewFeedback(f)}
                        >
                          View Feedback
                        </button>
                      </td>
                      {isFeedbackCardOpen && (
                        <ProgressMeetFeedbackCard
                          isOpen={isFeedbackCardOpen}
                          setIsOpen={setIsFeedbackCardOpen}
                          feedbackData={selectedFeedback}
                        />
                      )}
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan={6} className="px-4 py-2 text-center">
                    {noResultsMessage ? <>{noResultsMessage}</> : <></>}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  )
}
